import { defineMessages } from "react-intl";

export const translations = defineMessages({
  ContentDataDescription: {
    id: "MultiProgressWidgetInfo.ContentDataDescription",
    defaultMessage:
      "Percentage of users to whom the content is available and who liked, bookmarked, read, or participated in the content",
  },
});
